import { RefObject, useState, useEffect } from 'react';

export const usePortalPlacement = (
  anchorRef: RefObject<HTMLElement>,
  isOpen: boolean,
) => {
  const [coords, setCoords] = useState<{
    left: number;
    top: number;
    width: number;
  } | null>(null);

  useEffect(() => {
    if (!isOpen) {
      setCoords(null);
      return;
    }

    const calculateCoords = () => {
      if (anchorRef.current) {
        const rect = anchorRef.current.getBoundingClientRect();
        setCoords({
          left: rect.left + window.scrollX,
          top: rect.bottom + window.scrollY,
          width: rect.width,
        });
      }
    };

    calculateCoords();
    window.addEventListener('scroll', calculateCoords, true);
    window.addEventListener('resize', calculateCoords);

    return () => {
      window.removeEventListener('scroll', calculateCoords, true);
      window.removeEventListener('resize', calculateCoords);
    };
  }, [anchorRef, isOpen]);

  return coords;
};
